import * as R from 'ramda'
import {
  all,
  call,
  select,
  fork,
  take,
  takeEvery,
  takeLatest,
  put,
} from 'redux-saga/effects'

import injectSagas from 'helpers/injectSagas'

import {
  createTakeEveryName,
} from 'helpers/SagaUtil'

import {
  displayError
} from 'helpers/validator'

import {
  ADD_VALIDATION_CHECK_SUCCESS,
  ADD_VALIDATION_CHECK,
  DISPATCH_ADD_VALIDATION_CHECK,
  REMOVE_VALIDATION_CHECK_SUCCESS,
  REMOVE_VALIDATION_CHECK,
  DISPATCH_REMOVE_VALIDATION_CHECK,
  DISPATCH_VALIDATE_FORM,
  DISPATCH_VALIDATE_FORM_START,
  DISPATCH_VALIDATE_FORM_SUCCESS,
  UPDATE_VALIDATION_VALUE,
} from './constants'

import {
  addValidationCheckStart,
  addValidationCheckSuccess,
  addValidationCheck,
  removeValidationCheckStart,
  removeValidationCheckSuccess,
  removeValidationCheck,
  dispatchValidateForm,
  dispatchValidateFormSuccess,
  dispatchAddValidationCheck,
  dispatchRemoveValidationCheck,
} from './actions'

import {
  invalidCategorySelector as invalidSelector,
  validationElementCountSelector
} from './selectors'

function* addValidation(action) {
  const { id } = action
  yield put(addValidationCheckStart())
  yield put(addValidationCheck(id))
  yield put(addValidationCheckSuccess())
}

function* removeValidation(action) {
  const { id } = action
  yield put(removeValidationCheckStart())
  yield put(removeValidationCheck(id))
  yield put(removeValidationCheckSuccess())
}

function* watchAddValidationCheck() {
  yield takeEvery(DISPATCH_ADD_VALIDATION_CHECK, addValidation)
}

function* watchRemoveValidationCheck() {
  yield takeEvery(DISPATCH_REMOVE_VALIDATION_CHECK, removeValidation)
}

function* watchValidateElementSuccess() {
  let successCount = yield select(validationElementCountSelector)
  yield put(dispatchValidateForm())
  while (successCount) {
    yield take([ADD_VALIDATION_CHECK_SUCCESS, REMOVE_VALIDATION_CHECK_SUCCESS])
    successCount = R.dec(successCount)
  }
  yield put(dispatchValidateFormSuccess())
}

function* watchValidateForm() {
  yield takeLatest(DISPATCH_VALIDATE_FORM_START, watchValidateElementSuccess)
}

function* watchValidations() {
  yield all([
    fork(watchAddValidationCheck),
    fork(watchRemoveValidationCheck),
    fork(watchValidateForm),
  ])
}

const withValidationSagas = R.curry((validations, pathName, elementId, valueSelector) =>  {
  const path = `${pathName}.${elementId}.values`

  const takeEveryName = createTakeEveryName(path)

  function* runValueValidations() {
    let value = yield select(valueSelector)
    const error = displayError(value, validations)
    yield error
      ? put(dispatchAddValidationCheck(elementId))
      : put(dispatchRemoveValidationCheck(elementId))
  }

  function* watchValueChange() {
    yield takeEveryName(UPDATE_VALIDATION_VALUE, runValueValidations)
  }

  function* watchValidateForm() {
    yield takeEvery(DISPATCH_VALIDATE_FORM, runValueValidations)
  }

  function* sagas() {
    yield all([
      fork(watchValueChange),
      fork(watchValidateForm),
    ])
  }

  return injectSagas({ [`validation_${path}`]: sagas })
})

export {
  watchValidations,
  withValidationSagas
}
